export default "__VITE_ASSET__d35cbc01__"